export default __webpack_public_path__ + "static/media/plan.b6711e7a.png";